import {
  Typography,
  Stack,
  Tooltip,
  styled,
  TooltipProps,
  tooltipClasses,
} from '@mui/material';
import Brightness1Icon from '@mui/icons-material/Brightness1';
import storeConnector from '@src/store/storeConnector';
import { getModeStatusClass } from '../../utils';
import { SiteMeta } from '@src/types/SiteMeta';
import useAlias from '@src/hooks/useAlias';
import { StatusType, StatusTypeKey } from './TemplatesCard/types';

interface TemplatesCardStatusesProps {
  scadaStatus: string | number | null | undefined;
  activeStatus: string | number | null | undefined;
  hmiStatus: string | number | null | undefined;
  statusTypes: StatusType[];
  siteMeta: SiteMeta;
}

const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 250,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}));

function TemplatesCardStatuses({
  scadaStatus,
  activeStatus,
  hmiStatus,
  statusTypes,
  siteMeta,
}: TemplatesCardStatusesProps) {
  const alias = useAlias();

  return (
    <Stack direction='row' spacing={2} sx={{ mt: 2 }}>
      {statusTypes.map(({ key, tooltipMessage }) => {
        if (
          !siteMeta.ui.features?.ScadaConfig_Enabled &&
          key === StatusTypeKey.SCADA
        ) {
          return null;
        }

        return (
          <HtmlTooltip
            title={
              <>
                <Typography variant='body2' color='text.primary'>
                  {tooltipMessage}
                </Typography>
              </>
            }
            placement='bottom'
            key={key}
            arrow
          >
            <Stack spacing={1} direction='row' alignItems='center'>
              <Typography
                variant='caption'
                color='text.secondary'
                fontWeight={400}
                textTransform={'uppercase'}
              >
                {key + ' ' + alias('Status')}:
              </Typography>
              <Brightness1Icon
                sx={{
                  color: getModeStatusClass(
                    key === StatusTypeKey.SCADA
                      ? scadaStatus
                      : key === StatusTypeKey.HMI
                        ? hmiStatus
                        : activeStatus,
                  ),
                  fontSize: '0.8rem',
                }}
              />
            </Stack>
          </HtmlTooltip>
        );
      })}
    </Stack>
  );
}

export default storeConnector(TemplatesCardStatuses, {
  config: ['siteMeta'],
});
